import React, { useEffect } from "react";
import DWInfoCard from "../components/DWInfoCard";
import DWQuestionCard from "../components/DWQuestionCard";
import DWSlideCard from "../components/DWSlideCard";
import DidYouKnow from "../components/DidYouKnow";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import { divVariants } from "shared/components/animations";
const DW20Playing = ({
  isCzarPlayer,
  roomId,
  askedQuestion,
  currentPlayerCard,
  handleSetModalCard,
  playedCard,
  screens,
  joke,
  buzzer_sound,
  default_audio_effect
}) => {
  const czar_instructions_text = _.get(
    screens,
    "2_playing.czar.instructions_text ",

    "READ THE CARD OUT LOUD"
  );
  const other_instructions_top_text = _.get(
    screens,
    "2_playing.other.instructions_top_text",

    "Respond to the gold card with your funniest card!"
  );

  const other_instructions_bottom_text = _.get(
    screens,
    "2_playing.other.instructions_bottom_text",

    "Tap on a card to select"
  );
  useEffect(() => {
    if (!isCzarPlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isCzarPlayer, default_audio_effect]);

  const is_big_question_card = _.isEmpty(playedCard) && isCzarPlayer;
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="dw-playing"
    >
      <div>
        <DWInfoCard
          info1={isCzarPlayer ? "Card Czar" : ""}
          info2={
            isCzarPlayer ? czar_instructions_text : other_instructions_top_text
          }
          styled_info3={
            isCzarPlayer
              ? "Tap to flip a card, then read the sentence aloud."
              : other_instructions_bottom_text
          }
        />
        <DWQuestionCard
          askedQuestion={askedQuestion}
          is_big_question_card={is_big_question_card}
        />

        <DWSlideCard
          currentPlayerCard={currentPlayerCard}
          handleSetModalCard={handleSetModalCard}
          isCzarPlayer={isCzarPlayer}
          playedCard={playedCard}
          screens={screens}
        />
      </div>
      <DidYouKnow joke={joke} />
    </motion.div>
  );
};

export default DW20Playing;
